exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-116c68be]{margin-bottom:20px}.card-body h2[data-v-116c68be]{margin:0;font-size:2rem}", ""]);

// exports
